import React from "react";
import { Box, Container, Grid } from "@mui/material";

const Footer = () => (
	  <Box
	    component="footer"
	    sx={{
		          backgroundColor: "#f5f5f5",
			          py: 4,
			          borderTop: "1px solid #ddd",
			          mt: 4
		        }}
	  >
	    <Container maxWidth="md">
	      <Grid
	        container
	        spacing={4}
	        justifyContent="center"
	        alignItems="center"
	      >
	        <Grid item>
	          <Box
	            component="img"
	            src="images/defwithwords.png"
	            alt="Logo1"
	            sx={{ maxHeight: 60 }}
	          />
	        </Grid>
	        <Grid item>
	          <Box
	            component="img"
	            className="img2"
	            src="images/evertrue.svg"
	            alt="Logo2"
	            sx={{ maxHeight: 120 }}
	          />
	        </Grid>
	      </Grid>
	    </Container>
	  </Box>
);

export default Footer;

